import {
    ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP,
    ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP,
    ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP,
    ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP,
    REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
    REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
    REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP,
    OPEN_EDIT_SECTION_POPUP,
    UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
    ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP,
    REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP,
    ADD_REVIEWS_TO_SITE,
    REMOVE_REVIEWS_FOR_SITE,
    SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP,
    ADD_FAQS_TO_SITE,
    REMOVE_FAQS_FOR_SITE,
    SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP,
    SELECT_FIND_YOUR_PROJECT_PROJECTS,
    SELECT_FIND_YOUR_PROJECT_DESTINATIONS,
    UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD,
    PICK_SECTION_PAGE,
    PICK_LARGE_SNIPPET_PAGE,
    PICK_VALUE_PROPOSITION_PAGE,
    PICK_VALUE_PROPOSITION_BUTTON_TEXT,
    UPDATE_VALUE_PROPOSITION_BODY,
    UPDATE_VALUE_PROPOSITION_TITLE,
    UPDATE_MEET_US_EVENTS_PAGE,
    UPDATE_MEET_US_MEETINGS_PAGE,
    UPDATE_MEET_US_CAREERS_PAGE,
} from './types';

import {
    PICK_PROMOTIONAL_BOXES_PAGE,
    UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL,
    UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT,
    UPDATE_PROMOTIONAL_BOX_HEADING,
    UPDATE_PROMOTIONAL_BOX_SUBHEADING,
    UPDATE_PROMOTIONAL_BOX_TEXT,
    ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
} from './types/promotional_boxes_types';

export function updateImagesInTheSectionEditPopup(images) {
    return {
        type: ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP,
        payload: images,
    };
}

export function updateImageInTheSectionEditPopup(image) {
    return {
        type: ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP,
        payload: image,
    };
}

export function updateImageInValuePropositionPopup(
    valuePropositionIndex,
    image
) {
    return {
        type: ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            image: image,
        },
    };
}

export function updateImageInPromotionalBoxPopup(promotionalBoxIndex, image) {
    return {
        type: ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
        payload: {
            promotionalBoxIndex,
            image,
        },
    };
}

export function updateSnippetImageInLargeSnippetsPopup(
    largeSnippetIndex,
    image
) {
    return {
        type: ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
        },
    };
}

export function updateLogoImageInLargeSnippetsPopup(largeSnippetIndex, image) {
    return {
        type: ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
        },
    };
}

export function selectSectionSettingInTheSectionEditPopup(
    selectedOptions,
    forSetting
) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            selectedOptions,
            forSetting,
        },
    };
}

export function selectImageSettingInTheSectionEditPopup(
    selectedOptions,
    forSetting
) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            selectedOptions,
            forSetting,
        },
    };
}

export function selectVideoSettingInTheSectionEditPopup(
    selectedOptions,
    forSetting
) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            selectedOptions,
            forSetting,
        },
    };
}

export function deleteImageFromTheSectionEditPopup(image, index) {
    return {
        type: REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
        payload: {
            image,
            index,
        },
    };
}

export function deleteSingleImageFromTheSectionEditPopup() {
    return {
        type: REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
    };
}

export function deleteSnippetImageInLargeSnippetsPopup(
    image,
    largeSnippetIndex
) {
    return {
        type: REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            image: image,
            largeSnippetIndex: largeSnippetIndex,
        },
    };
}

export function deleteLogoImageInLargeSnippetsPopup(image, largeSnippetIndex) {
    return {
        type: REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            image: image,
            largeSnippetIndex: largeSnippetIndex,
        },
    };
}

export function deleteImageInValuePropositionPopup(
    image,
    valuePropositionIndex
) {
    return {
        type: REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP,
        payload: {
            image: image,
            valuePropositionIndex: valuePropositionIndex,
        },
    };
}

export function deleteImageInPromotionalBoxPopup(image, promotionalBoxIndex) {
    return {
        type: REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
        payload: {
            image,
            promotionalBoxIndex,
        },
    };
}

export function updateCroppedImageInTheSectionEditPopup(
    image,
    imageUrlBlob,
    imageBlobObject,
    index
) {
    return {
        type: UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
            index: index,
        },
    };
}

export function updateSingleCroppedImageInTheSectionEditPopup(
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateCroppedImageInValuePropositionPopup(
    valuePropositionIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateCroppedImageInPromotionalBoxPopup(
    promotionalBoxIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
        payload: {
            promotionalBoxIndex,
            image,
            imageUrlBlob,
            imageBlobObject,
        },
    };
}

export function updateCroppedSnippetImageInLargeSnippetsPopup(
    largeSnippetIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateCroppedLogoImageInLargeSnippetsPopup(
    largeSnippetIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateImageMetaInTheSectionEditPopup(imageMeta, index) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            imageMeta: imageMetaUpdated,
            index,
        },
    };
}

export function updateImageCropRatioInTheSectionEditPopup(cropRatioId, index) {
    return {
        type: UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            cropRatioId,
            index,
        },
    };
}

export function updateSingleImageMetaInTheSectionEditPopup(imageMeta) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            imageMeta: imageMetaUpdated,
        },
    };
}

export function updateSingleImageCropRatioInTheSectionEditPopup(cropRatioId) {
    return {
        type: UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            cropRatioId,
        },
    };
}

export function updateImageMetaInValuePropositionPopup(
    valuePropositionIndex,
    imageMeta
) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP,
        payload: {
            valuePropositionIndex,
            imageMeta: imageMetaUpdated,
        },
    };
}

export function updateImageMetaInPromotionalBoxPopup(
    promotionalBoxIndex,
    imageMeta
) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP,
        payload: {
            promotionalBoxIndex,
            imageMeta: imageMetaUpdated,
        },
    };
}

export function updateSnippetImageMetaInLargeSnippetsPopup(
    largeSnippetIndex,
    imageMeta
) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex,
            imageMeta: imageMetaUpdated,
        },
    };
}

export function updateLogoImageMetaInLargeSnippetsPopup(
    largeSnippetIndex,
    imageMeta
) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex,
            imageMeta: imageMetaUpdated,
        },
    };
}

export function updateImagesSortOrderInTheSectionEditPopup(images) {
    return {
        type: UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            images,
        },
    };
}

export function updateInstructionsFieldInTheSectionEditPopup(instructions) {
    return {
        type: UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP,
        payload: instructions,
    };
}

export function updateTitleFieldInTheSectionEditPopup(newValue) {
    return {
        type: UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP,
        payload: newValue,
    };
}

export function updateThumbCroppedImageInTheSectionEditPopup(
    image,
    imageUrlBlob,
    imageBlobObject,
    index
) {
    return {
        type: UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
            index: index,
        },
    };
}

export function updateSingleThumbCroppedImageInTheSectionEditPopup(
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateThumbCroppedImageInValuePropositionPopup(
    valuePropositionIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateThumbCroppedImageInPromotionalBoxPopup(
    promotionalBoxIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
        payload: {
            promotionalBoxIndex,
            image,
            imageUrlBlob,
            imageBlobObject,
        },
    };
}

export function updateThumbCroppedSnippetImageInLargeSnippetsPopup(
    largeSnippetIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateThumbCroppedLogoImageInLargeSnippetsPopup(
    largeSnippetIndex,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
        },
    };
}

export function updateBodyFieldInTheSectionEditPopup(body) {
    return {
        type: UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP,
        payload: body,
    };
}

export function updateVideoUrlFieldInTheSectionEditPopup(id, url) {
    return {
        type: UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            id,
            url,
        },
    };
}

export function updateSingleVideoUrlFieldInTheSectionEditPopup(id, url) {
    return {
        type: UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            id,
            url,
        },
    };
}

export function openEditSectionPopup(pageId, sectionId, sectionToEdit) {
    return {
        type: OPEN_EDIT_SECTION_POPUP,
        payload: {
            pageId,
            sectionId,
            sectionToEdit,
        },
    };
}

export function updateMapLocationInTheSectionEditPopup(
    locationId,
    newDescription
) {
    return {
        type: UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            locationId: locationId,
            newDescription: newDescription,
        },
    };
}

export function updateIncludedSelectedFeatures(included) {
    return {
        type: UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            included: included,
        },
    };
}

export function updateNotIncludedSelectedFeatures(notIncluded) {
    return {
        type: UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            notIncluded: notIncluded,
        },
    };
}

export function updateDocumentsInTheSectionEditPopup(documents) {
    return {
        type: ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP,
        payload: documents,
    };
}

export function deleteDocumentFromTheSectionEditPopup(document, index) {
    return {
        type: REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP,
        payload: {
            document: document,
            index: index,
        },
    };
}

export function addReviewsToSite(review) {
    return {
        type: ADD_REVIEWS_TO_SITE,
        payload: {
            review: review,
        },
    };
}

export function removeReviewsForSite(reviewId) {
    return {
        type: REMOVE_REVIEWS_FOR_SITE,
        payload: {
            reviewId: reviewId,
        },
    };
}

export function sortSelectedReviews(selectedReviews) {
    return {
        type: SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            selectedReviews: selectedReviews,
        },
    };
}

export function updateFormTypeFieldInTheSectionEditPopup(formType) {
    return {
        type: UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            formType: formType,
        },
    };
}

export function addFaqsToSite(faq) {
    return {
        type: ADD_FAQS_TO_SITE,
        payload: {
            faq: faq,
        },
    };
}

export function removeFaqsForSite(faqId) {
    return {
        type: REMOVE_FAQS_FOR_SITE,
        payload: {
            faqId: faqId,
        },
    };
}

export function sortSelectedFaqs(selectedFaqs) {
    return {
        type: SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP,
        payload: {
            selectedFaqs: selectedFaqs,
        },
    };
}

export function changeFindYourProjectDestinations(destinations) {
    return {
        type: SELECT_FIND_YOUR_PROJECT_DESTINATIONS,
        destinations,
        touched: true,
    };
}

export function changeFindYourProjectProjects(projects) {
    return {
        type: SELECT_FIND_YOUR_PROJECT_PROJECTS,
        projects,
        touched: true,
    };
}

export function pickLargeSnippetPage(largeSnippetIndex, pageId, pageTitle) {
    return {
        type: PICK_LARGE_SNIPPET_PAGE,
        payload: {
            largeSnippetIndex: largeSnippetIndex,
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}

export function updateMeetingsBodyFieldInTheSectionEditPopup(body) {
    return {
        type: UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP,
        payload: body,
    };
}

export function updateCareersBodyFieldInTheSectionEditPopup(body) {
    return {
        type: UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP,
        payload: body,
    };
}

export function updateGroupTripsBannerSectionSubheadingField(body) {
    return {
        type: UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD,
        payload: body,
    };
}

export function pickSectionPage(pageId, pageTitle) {
    return {
        type: PICK_SECTION_PAGE,
        payload: {
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}

export function pickValuePropositionPage(
    valuePropositionIndex,
    pageId,
    pageTitle
) {
    return {
        type: PICK_VALUE_PROPOSITION_PAGE,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}

export function pickPromotionalBoxesPage(
    promotionalBoxIndex,
    pageId,
    pageTitle
) {
    return {
        type: PICK_PROMOTIONAL_BOXES_PAGE,
        payload: {
            promotionalBoxIndex,
            pageId,
            pageTitle,
        },
    };
}

export function updateValuePropositionButtonText(valuePropositionIndex, text) {
    return {
        type: PICK_VALUE_PROPOSITION_BUTTON_TEXT,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            text,
        },
    };
}

export function updateValuePropositionTitle(valuePropositionIndex, title) {
    return {
        type: UPDATE_VALUE_PROPOSITION_TITLE,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            title: title,
        },
    };
}

export function updateValuePropositionBody(valuePropositionIndex, body) {
    return {
        type: UPDATE_VALUE_PROPOSITION_BODY,
        payload: {
            valuePropositionIndex: valuePropositionIndex,
            body: body,
        },
    };
}

export function updatePromotionalBoxExternalUrl(
    promotionalBoxIndex,
    external_url
) {
    return {
        type: UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL,
        payload: {
            promotionalBoxIndex,
            external_url,
        },
    };
}

export function updatePromotionalBoxButtonText(
    promotionalBoxIndex,
    button_text
) {
    return {
        type: UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT,
        payload: {
            promotionalBoxIndex,
            button_text,
        },
    };
}

export function updatePromotionalBoxHeading(promotionalBoxIndex, heading) {
    return {
        type: UPDATE_PROMOTIONAL_BOX_HEADING,
        payload: {
            promotionalBoxIndex,
            heading,
        },
    };
}

export function updatePromotionalBoxSubheading(
    promotionalBoxIndex,
    subheading
) {
    return {
        type: UPDATE_PROMOTIONAL_BOX_SUBHEADING,
        payload: {
            promotionalBoxIndex,
            subheading,
        },
    };
}

export function updatePromotionalBoxText(promotionalBoxIndex, text) {
    return {
        type: UPDATE_PROMOTIONAL_BOX_TEXT,
        payload: {
            promotionalBoxIndex,
            text,
        },
    };
}

export function updateMeetUsEventsPage(pageId, pageTitle) {
    return {
        type: UPDATE_MEET_US_EVENTS_PAGE,
        payload: {
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}

export function updateMeetUsMeetingsPage(pageId, pageTitle) {
    return {
        type: UPDATE_MEET_US_MEETINGS_PAGE,
        payload: {
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}

export function updateMeetUsCareersPage(pageId, pageTitle) {
    return {
        type: UPDATE_MEET_US_CAREERS_PAGE,
        payload: {
            pageId: pageId,
            pageTitle: pageTitle,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/sections/actions.js